import FS from '../FetchService';

export default class CountryService {
  static async page(params) {
    return FS.get(`/countries?${params}`);
  }
}


// WEBPACK FOOTER //
// ./src/services/administration/CountryService.js